<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="lot-tab">
	<div class="table-responsive" *ngIf="transactions">
		<table class="table table-striped table-bordered table-curved" *ngIf="transactions.length else nodata">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="transition.bind(this)">
				<th jhiSortBy="lot.lotId"><span jhiTranslate="lot.lotId">Lot ID</span> <span class="fa fa-sort"></span></th>
				<th jhiSortBy="lot.stockId"><span jhiTranslate="lot.stockId">Stock ID</span> <span class="fa fa-sort"></span></th>
				<th jhiSortBy="lot.unitName"><span jhiTranslate="lot.unitName">Units</span> <span class="fa fa-sort"></span></th>
				<th jhiSortBy="transactionType"><span jhiTranslate="transaction.transactionType">Transaction Type</span> <span class="fa fa-sort"></span></th>
				<th jhiSortBy="transactionStatus"><span jhiTranslate="transaction.transactionStatus">Transaction Status</span> <span class="fa fa-sort"></span></th>
				<th jhiSortBy="amount"><span jhiTranslate="transaction.amount">Amount</span> <span class="fa fa-sort"></span></th>
				<th jhiSortBy="createdDate"><span jhiTranslate="lot.createdDate">Created Date</span> <span class="fa fa-sort"></span></th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let transaction of transactions ;trackBy: trackId">
				<td>{{transaction.lot.lotId}}</td>
				<td>{{transaction.lot.stockId}}</td>
				<td>{{transaction.lot.unitName}}</td>
				<td>{{ 'inventoryManagerApp.transaction.type.' + transaction.transactionType | translate }}</td>
				<td>{{ 'inventoryManagerApp.transaction.status.' + transaction.transactionStatus | translate }}</td>
				<td>{{transaction.amount}}</td>
				<td>{{transaction.createdDate}}</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<table class="table table-striped table-bordered table-curved">
				<thead>
				<tr>
					<th></th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td jhiTranslate="no.data"></td>
				</tr>
				</tbody>
			</table>
		</ng-template>
	</div>
	<div *ngIf="transactions && transactions.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count [page]="page" [total]="queryCount" [itemsPerPage]="itemsPerPage"></jhi-item-count>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
